<template>
  <hooper :settings="settings" ref="hooper">
    <slide v-for="(slide, idx) in slides" :key="idx" :index="idx">
      <a :href="slide" target="_blank" class="object-image">
        <img :src="slide" alt="Objekt" style="width: 100%">
        <span class="object-image-expand" v-if="hasPhotos"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-expand"></use></svg></span>
      </a>
    </slide>

    <hooper-navigation slot="hooper-addons" v-if="needNavigation">
      <svg class="icon icon-arrowLeft icon-keyboard-arrow-right" viewBox="0 0 24 24" width="24px" height="24px">
        <title>Arrow Left</title>
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M8.29,17.29,13.59,12,8.29,6.71A1,1,0,0,1,9.71,5.29l6,6a1,1,0,0,1,0,1.42l-6,6a1,1,0,0,1-1.42,0A1,1,0,0,1,8.29,17.29Z" />
      </svg>

      <svg class="icon icon-arrowRight icon-keyboard-arrow-left" viewBox="0 0 24 24" width="24px" height="24px">
        <title>Arrow Right</title>
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M15.71,6.71,10.41,12l5.3,5.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0l-6-6a1,1,0,0,1,0-1.42l6-6a1,1,0,1,1,1.42,1.42Z" />
      </svg>
    </hooper-navigation>

    <hooper-pagination slot="hooper-addons" v-if="needNavigation"></hooper-pagination>
  </hooper>
</template>

<script>
// See: https://baianat.github.io/hooper/api.html#props
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from 'hooper'

export default {
  name: 'TheImageSlider',
  components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    objekt: {
      type: Object
    }
  },
  data () {
    return {
      settings: {
        itemsToShow: 1,
        shortDrag: false,
        centerMode: true,
        infiniteScroll: false,
        vertical: false
      },

      defaultImages: ['/static/img/object-large-opacity.svg']
    }
  },
  watch: {
    'slides': function (val, oldVal) {
      if (this.$refs.hooper !== undefined) {
        // This re-calculate pagination addon and such...
        this.$refs.hooper.restart()
      }
    }
  },
  computed: {
    slides: function () {
      if (!this.items || this.items.length < 1) {
        return this.defaultImages
      } else {
        return this.items
      }
    },
    hasPhotos: function () {
      return this.items && this.items.length > 0
    },
    needNavigation: function () {
      return this.slides.length > 1
    }
  },
  methods: {
    getExternalUrl: function (idx, slide) {
      if (!this.hasPhotos) {
        return 'javascript:;'
      }

      return 'https://www.blomqvist.no/image/fwview/' + this.objekt.Objektnr + '/' + idx
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheImageSlider.vue